import * as React from 'react';
import moment from 'moment';
import { Input } from 'src/shared/components/ui/input';
import styles from './BasicTimePicker.module.scss';

export type BasicTimePickerProps = {
    label?: string;
    value: Date | null;
    disablePast?: boolean;
    disableFuture?: boolean;
    ampm?: boolean;
    views?: Array<'hours' | 'minutes' | 'seconds'>;
    onChange: (value: Date | null) => void;
    disabled?: boolean;
};

const BasicTimePicker = (props: BasicTimePickerProps) => {
    const { label, value, onChange, disablePast, disableFuture, ampm = false, views = ['hours', 'minutes'], disabled = false } = props;

    const format = ampm ? 'hh:mm A' : 'HH:mm';
    const [timeText, setTimeText] = React.useState<string>(value ? moment(value).format(format) : '');

    React.useEffect(() => {
        if (value) {
            setTimeText(moment(value).format(format));
        } else {
            setTimeText('');
        }
    }, [value, format]);

    const handleChange = (text: string) => {
        setTimeText(text);

        const parsed = moment(text, [format, 'HH:mm', 'hh:mm A'], true);
        if (!parsed.isValid()) {
            return;
        }

        const base = value ? moment(value) : moment();

        let next = base.clone();
        next = next.hours(parsed.hours()).minutes(parsed.minutes()).seconds(0).milliseconds(0);

        if (views && !views.includes('minutes')) {
            next = next.minutes(0);
        }

        const now = moment();
        if (disablePast && next.isBefore(now)) {
            onChange(now.toDate());
            return;
        }

        if (disableFuture && next.isAfter(now)) {
            onChange(now.toDate());
            return;
        }

        onChange(next.toDate());
    };

    return (
        <div className={styles.basicTimePicker}>
            {label ? <div className='mb-1 text-sm font-medium text-foreground'>{label}</div> : null}
            <Input
                aria-label={label}
                value={timeText}
                onChange={e => handleChange(e.target.value)}
                placeholder={format}
                disabled={disabled}
            />
        </div>
    );
};

export default BasicTimePicker;
